export default function CODNoticeSection() {
    const items = [
        "श्री बालाजी मसाले की डीलरशिप और थोक ऑर्डर लेने के लिए आज ही संपर्क करें",
    ];

    return (
        <section className="w-full bg-[#930e21] overflow-hidden sticky top-0 z-[60] h-10">
            <div className="marquee-track h-full">
                {[...items, ...items].map((text, index) => (
                    <div className="marquee-item" key={index}>
                        📢 {text} |
                        📞
                        <a href="tel:+919993002880" className="phone">
                            +91 9993002880
                        </a>
                        {"  |  "}
                        <a href="tel:+919981435600" className="phone">
                            +91 9981435600
                        </a>
                    </div>
                ))}
            </div>

            <style>{`
    .marquee-track {
        display: flex;
        align-items: center;
        width: max-content;
        animation: marquee 40s linear infinite; /* slow speed */
    }
    .marquee-item {
        padding-right: 80px;
        color: white;
        font-size: 14px;
        font-weight: 600;
        white-space: nowrap;
    }
    .phone {
        color: #ffd700;
        font-weight: 700;
        text-decoration: none;
        margin: 0 6px;
    }
    @keyframes marquee {
        from { transform: translateX(0); }
        to { transform: translateX(-50%); }
    }
`}</style>
        </section>
    );
}